<template>
  <div>
    <ValidationObserver class="w-100" v-slot="{ handleSubmit }">
      <b-modal :no-enforce-focus="true" v-model="modal">
        <template #modal-header="{ close }">
          <h5>Cấu hình Callio cho nhân viên {{ staff.name }}</h5>
          <b-button size="sm" variant="light" @click="close"> x </b-button>
        </template>
        <div>
          <form @submit.prevent="handleSubmit(submit)">
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Email</label>
              <div class="col-sm-8">
                <input :value="config.email || staff.userName" disabled />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Số điện thoại</label>
              <div class="col-sm-8">
                <input :value="config.phone || staff.mobile" disabled />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Họ tên</label>
              <div class="col-sm-8">
                <input :value="config.name || staff.name" disabled />
              </div>
            </div>
            <ValidationProvider rules="required" vid="ext" name="Số nhánh">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="ext" class="col-sm-4 col-form-label"
                  >Số nhánh <span style="color: red">*</span></label
                >
                <div class="col-sm-8">
                  <input id="ext" autocomplete="off" v-model.trim="config.ext" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="required" vid="extPassword" name="Mật khẩu nhánh">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="extPassword" class="col-sm-4 col-form-label"
                  >Mật khẩu nhánh <span style="color: red">*</span></label
                >
                <div class="col-sm-8">
                  <input
                    id="extPassword"
                    autocomplete="new-password"
                    v-model.trim="config.extPassword"
                    type="password"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Trạng thái</label>
              <div class="col-sm-8">
                <b-form-checkbox v-model="config.isActive" switch />
              </div>
            </div>
          </form>
        </div>
        <template #modal-footer="{ close }">
          <b-button variant="light" @click="close"> Đóng </b-button>
          <b-button variant="primary" @click="handleSubmit(submit)"> Lưu </b-button>
        </template>
      </b-modal>
    </ValidationObserver>
  </div>
</template>
<script>
  import { CallIoService } from '@/services/callio.service'
  export default {
    data() {
      return {
        modal: false,
        staff: {},
        config: {},
      }
    },
    created() {},
    methods: {
      async open(staff) {
        const response = await CallIoService.getUserCallIo({
          crmUserId: staff.id,
        })
        if (response.success === true) {
          const data = response.data
          this.config = {
            isActive: data.active,
            userId: data.crmUserId,
            email: data.email,
            ext: data.ext,
            extPassword: data.extPassword,
            name: data.name,
            phone: data.phone,
          }
        } else {
          this.config = {
            isActive: false,
            userId: staff.id,
          }
        }
        this.staff = staff
        this.modal = true
      },
      async submit() {
        this.$parent.showLoading = true
        try {
          const params = {
            userId: this.config.userId,
            ext: this.config.ext,
            extPassword: this.config.extPassword,
            isActive: this.config.isActive,
          }
          const response = await CallIoService.callioConfig(params)
          if (response.success === false) {
            this.showFailMx(response.message)
          } else {
            this.showSuccessMx('Cấu hình Callio Thành công')
            this.modal = false
          }
        } catch (error) {
          this.showFailMx(error.message)
        } finally {
          this.$parent.showLoading = false
        }
      },
    },
  }
</script>
